// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__Z6iPf","reactions-wrapper":"reactions-wrapper__qmdk1"};